/**
 * Public backend route resolving a user's avatar by wwid.
 * Returns the stored picture (redirect) if it exists, otherwise an initials SVG.
 * `fullName` is only used to render those fallback initials.
 */
export const getUserAvatarUrl = (wwid, fullName = '') =>
  `/api/v2/users/${wwid}/avatar?userFullName=${encodeURIComponent(fullName || '')}`;
